﻿import { addTelemetryEventGA4, GA4EventAction, GA4EventCategory, GA4EventType } from '../../Telemetry/TelemetryGA4';

export function addTelemetryEventForStep(step: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7) {
	addTelemetryEventGA4({
		...getEventAndActionForStep(step),
		category: GA4EventCategory.ecommerce_directrental,
		label: step,
	});
}

export function getEventAndActionForStep(step: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7): {
	event: GA4EventType;
	action: GA4EventAction;
} {
	switch (step) {
		case 0:
			return { event: GA4EventType.begin_checkout, action: GA4EventAction.aloita_vuokraus };
		case 1:
			return { event: GA4EventType.checkout_step_vuokrausehdot_1, action: GA4EventAction.vuokrausehdot };
		case 2:
			return { event: GA4EventType.checkout_step_vuokrasopimus_2, action: GA4EventAction.vuokrasopimus };
		case 3:
			return { event: GA4EventType.checkout_step_tunnistautuminen_3, action: GA4EventAction.tunnistautuminen };
		case 4:
			return { event: GA4EventType.checkout_step_taydenna_tiedot_4, action: GA4EventAction.taydenna_tiedot };
		case 5:
			return {
				event: GA4EventType.checkout_step_tietojen_tarkistus_5,
				action: GA4EventAction.tietojen_tarkistus,
			};
		case 6:
			return { event: GA4EventType.checkout_step_yhteenveto_6, action: GA4EventAction.yhteenveto };
		case 7:
			return { event: GA4EventType.checkout_step_maksaminen_7, action: GA4EventAction.maksaminen };
	}
}
